import { createContext, useState, useCallback, useContext } from 'react'
import FetchData from '../utils/FetchData'

const ProfileContext = createContext()

export const useProfileContext = () => useContext(ProfileContext)

export const ProfileProvider = ({ children }) => {
  const [userProfile, setUserProfile] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchProfile = useCallback(async () => {
    setLoading(true)
    try {
      const data = await FetchData.userProfile()
      if (data) setUserProfile(data)
      return data
    } catch (error) {
      console.error('Error fetching profile:', error)
      setUserProfile(null)
    } finally {
      setLoading(false)
    }
  }, [])

  return (
    <ProfileContext.Provider
      value={{ userProfile, setUserProfile, fetchProfile, loading }}
    >
      {children}
    </ProfileContext.Provider>
  )
}
